import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './discovery.module.scss';

const METADATA = Metadata.define({
  description: 'Secondary discovery badge indicator.',
  name: 'Discovery Secondary Badge',
});

export default class SpdsIndicatorBadgeDiscoverySecondary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  secondary = true;
  variantClass = 'spds-indicator-badge-discovery';
  variantStyles = styles;
}

export const BADGE_DISCOVERY_SECONDARY_METADATA = SpdsIndicatorBadgeDiscoverySecondary.metadata;
